class MonthlyHighlightsDialog extends HTMLElement {
  swiper = null;
  allVideos = [];
  isFirstOpen = true;

  // Comments state
  commentsMediaId = '';
  commentsPage = 1;
  commentsPageSize = 15;
  commentsHasMore = true;
  commentsOpen = false;

  connectedCallback() {
    this.shopSelect = this.dataset.shopSelect;
    this.baseUrl =
      this.dataset.requestType === 'prod'
        ? 'https://h130-app-server-us.hoverx1.cn'
        : 'https://h130-app-server-test-us.hoverx1.cn';
    if (this.shopSelect === 'JP') {
      this.baseUrl =
        this.dataset.requestType === 'prod'
          ? 'https://h130-app-server-jp.hoverx1.cn'
          : 'https://h130-app-server-test-jp.hoverx1.cn';
    }
    this.initCloseEvents();
    this.initCommentsEvents();
  }

  // ==================== Modal Open/Close ====================

  initCloseEvents() {
    const closeBtn = this.querySelector('.mh-close-btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeModal());
    }
    const mask = this.querySelector('.mh-modal-mask');
    if (mask) {
      mask.addEventListener('click', (e) => {
        if (e.target === mask) this.closeModal();
      });
    }
  }

  openWithVideos(videos, startIndex) {
    this.allVideos = videos;
    this.destroySwiper();
    this.initSwiper();
    this.rebuildSlides();
    this.showModal(startIndex);
  }

  showModal(videoIndex) {
    const modal = this.querySelector('.mh-modal');
    const mask = this.querySelector('.mh-modal-mask');
    modal.style.display = 'block';
    mask.style.display = 'block';
    setTimeout(() => modal.classList.add('show'), 10);
    document.body.classList.add('mh-modal-open');
    if (typeof window.zzLockBodyScroll === 'function') {
      window.zzLockBodyScroll();
    }
    if (this.swiper && typeof videoIndex === 'number') {
      this.swiper.slideTo(videoIndex, 0);
    }
    this.isFirstOpen = false;
    setTimeout(() => this.playActiveSlideVideo(), 200);
  }

  closeModal() {
    const modal = this.querySelector('.mh-modal');
    const mask = this.querySelector('.mh-modal-mask');
    if (typeof window.zzUnlockBodyScroll === 'function') {
      window.zzUnlockBodyScroll();
    }
    modal.classList.remove('show');
    setTimeout(() => {
      modal.style.display = 'none';
      mask.style.display = 'none';
      this.pauseAllVideos();
    }, 200);
    document.body.classList.remove('mh-modal-open');
    this.closeComments();
  }

  // ==================== Swiper ====================

  initSwiper() {
    const container = this.querySelector('.mh-swiper');
    if (!container) return;
    const isDesktop = window.innerWidth >= 1024;
    this.swiper = new Swiper(container, {
      direction: isDesktop ? 'horizontal' : 'vertical',
      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },
      virtual: { slides: [] },
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: !isDesktop,
      on: {
        slideChangeTransitionEnd: () => {
          this.pauseAllVideos();
          this.playActiveSlideVideo();
        },
        slideChange: () => {
          if (!this.swiper) return;
          const idx = this.swiper.activeIndex;
          if (idx === this.swiper.virtual.slides.length - 1) {
            const list = document.querySelector('monthly-highlights-list');
            if (list) list.loadNextPage();
          }
        },
      },
    });
  }

  destroySwiper() {
    if (!this.swiper) return;
    const wrapper = this.querySelector('#mh-swiper-wrapper');
    if (wrapper) wrapper.innerHTML = '';
    this.swiper.destroy(true, true);
    this.swiper = null;
  }

  rebuildSlides() {
    if (!this.swiper) return;
    const template = this.getTemplate('mh-slide-template');
    this.swiper.virtual.slides = [];
    this.allVideos.forEach((item) => {
      const html = this.fillSlideTemplate(template, item);
      this.swiper.virtual.slides.push(html);
    });
    this.swiper.virtual.update();
  }

  addNewSlides(newVideos) {
    if (!this.swiper) return;
    const template = this.getTemplate('mh-slide-template');
    newVideos.forEach((item) => {
      const html = this.fillSlideTemplate(template, item);
      this.swiper.virtual.slides.push(html);
    });
    this.swiper.virtual.update();
  }

  fillSlideTemplate(template, item) {
    const avatar = (item.userInfo && item.userInfo.avatar) || '';
    const nickname = (item.userInfo && item.userInfo.nickname) || '';
    return template
      .replace(/{videoUrl}/g, item.videoUrl || '')
      .replace(/{poster}/g, item.pictureUrl || '')
      .replace(/{avatar}/g, avatar)
      .replace(/{nickname}/g, nickname)
      .replace(/{content}/g, item.content || '')
      .replace(/{likeCount}/g, item.likeCount || 0)
      .replace(/{commentCount}/g, item.commentCount || 0)
      .replace(/{mediaId}/g, item.id || '');
  }

  // ==================== Video Playback ====================

  pauseAllVideos() {
    this.querySelectorAll('.mh-slide-video').forEach((v) => v.pause());
  }

  playActiveSlideVideo() {
    const active = this.querySelector('.swiper-slide-active');
    if (!active) return;
    const video = active.querySelector('.mh-slide-video');
    if (!video) return;
    video.play().catch(() => {});
    this.initSlideControls(active, video);
  }

  initSlideControls(slide, video) {
    const playPause = slide.querySelector('.mh-play-pause');
    const progressWrap = slide.querySelector('.mh-progress-wrap');
    const progressBar = slide.querySelector('.mh-progress-bar');
    const volumeBtn = slide.querySelector('.mh-volume-btn');
    const mbVolumeBtn = slide.querySelector('.mh-mb-volume-btn');
    const mbCloseBtn = slide.querySelector('.mh-mb-close-btn');
    const playBtn = slide.querySelector('.mh-play-btn');
    const overlay = slide.querySelector('.mh-overlay');
    const currentTimeEl = slide.querySelector('.mh-current-time');
    const totalTimeEl = slide.querySelector('.mh-total-time');

    // 用 video 元素而非 slide 元素做标记：
    // Swiper 虚拟列表会复用 slide 元素并重写其 innerHTML，
    // 若标记在 slide 上，重写后按钮监听丢失但标记仍在，控件会失效。
    if (video._controlsBound) return;
    video._controlsBound = true;

    const isDesktop = window.innerWidth >= 1024;

    // Play/Pause
    if (isDesktop && playPause) {
      playPause.addEventListener('click', () => {
        video.paused ? video.play() : video.pause();
      });
    } else if (overlay) {
      overlay.addEventListener('click', () => {
        video.paused ? video.play() : video.pause();
      });
    }
    if (playBtn) {
      playBtn.addEventListener('click', () => {
        video.play();
        playBtn.style.display = 'none';
      });
    }

    // Progress
    let isDragging = false;
    video.addEventListener('timeupdate', () => {
      if (isDragging || !progressBar) return;
      const pct = (video.currentTime / video.duration) * 100;
      progressBar.style.width = pct + '%';
      if (currentTimeEl) currentTimeEl.textContent = this.formatTime(video.currentTime);
    });

    if (progressWrap) {
      const updateTime = (e) => {
        const rect = progressWrap.getBoundingClientRect();
        const clientX = e.clientX || (e.touches && e.touches[0].clientX);
        const pos = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        video.currentTime = pos * video.duration;
        if (progressBar) progressBar.style.width = (pos * 100) + '%';
      };

      progressWrap.addEventListener('mousedown', (e) => {
        e.stopPropagation();
        isDragging = true;
        updateTime(e);
      });
      progressWrap.addEventListener('mousemove', (e) => {
        e.stopPropagation();
        if (isDragging) updateTime(e);
      });
      document.addEventListener('mouseup', () => {
        if (isDragging) setTimeout(() => { isDragging = false; }, 100);
      });
      progressWrap.addEventListener('touchstart', (e) => {
        isDragging = true;
        updateTime(e);
      });
      document.addEventListener('touchmove', (e) => {
        if (isDragging) { e.preventDefault(); updateTime(e); }
      }, { passive: false });
      document.addEventListener('touchend', () => {
        if (isDragging) setTimeout(() => { isDragging = false; }, 100);
      });
    }

    // Volume
    const updateVolumeIcon = () => {
      const mutedSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.7271 6.92578C13.7191 7.58537 14.3729 8.71327 14.3729 9.99388C14.3729 11.2745 13.7191 12.4024 12.7271 13.062" stroke="white" stroke-width="1.15381" stroke-linecap="round"/><path d="M14.7729 4.91113C16.4168 6.00409 17.5001 7.87303 17.5001 9.99501C17.5001 12.117 16.4168 13.9859 14.7729 15.0789" stroke="white" stroke-width="1.15381" stroke-linecap="round"/><path d="M3.50098 3.79785L15.8753 16.1722" stroke="white" stroke-width="1.25" stroke-linecap="round"/><path d="M10 12.5468V16.4891C9.9997 17.1018 9.25411 17.4031 8.82812 16.9628L5.22754 13.2372H1.93164C1.5553 13.2371 1.25022 12.9319 1.25 12.5555V7.43153C1.25 7.05503 1.55517 6.74997 1.93164 6.74988H4.20312L10 12.5468ZM8.82812 3.0243C9.25423 2.58404 10 2.88606 10 3.49891V10.4257L5.76562 6.19129L8.82812 3.0243Z" fill="white"/></svg>';
      const unmutedSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M1.25 7.43155C1.25 7.05501 1.55525 6.74976 1.9318 6.74976H5.2272L8.82779 3.02494C9.25384 2.58419 9.9998 2.8858 9.9998 3.49881V16.4891C9.9998 17.1021 9.25375 17.4037 8.82773 16.9629L5.2272 13.2373H1.9318C1.55525 13.2373 1.25 12.932 1.25 12.5555V7.43155Z" fill="white"/><path d="M12.7271 6.92578C13.7191 7.58537 14.3729 8.71327 14.3729 9.99388C14.3729 11.2745 13.7191 12.4024 12.7271 13.062" stroke="white" stroke-width="1.15381" stroke-linecap="round"/><path d="M14.7729 4.91016C16.4168 6.00311 17.5001 7.87205 17.5001 9.99403C17.5001 12.116 16.4168 13.9849 14.7729 15.0779" stroke="white" stroke-width="1.15381" stroke-linecap="round"/></svg>';
      const icon = video.muted ? mutedSvg : unmutedSvg;
      if (volumeBtn) volumeBtn.innerHTML = icon;
      if (mbVolumeBtn) mbVolumeBtn.innerHTML = icon;
    };

    const toggleMute = (e) => {
      e.stopPropagation();
      video.muted = !video.muted;
      updateVolumeIcon();
    };
    if (volumeBtn) volumeBtn.addEventListener('click', toggleMute);
    if (mbVolumeBtn) mbVolumeBtn.addEventListener('click', toggleMute);

    // Duration
    const setDuration = () => {
      if (totalTimeEl && video.duration) {
        totalTimeEl.textContent = this.formatTime(video.duration);
      }
    };
    video.addEventListener('loadedmetadata', setDuration);
    video.addEventListener('loadeddata', setDuration);
    if (video.readyState >= 2) setDuration();

    // Play/Pause UI
    const pauseSvg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="6.6" y="5.1" width="3.6" height="13.8" rx="0.9" fill="white"/><rect x="13.8" y="5.1" width="3.6" height="13.8" rx="0.9" fill="white"/></svg>';
    const playSvg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2216 10.4612C20.3819 11.159 20.3819 12.841 19.2216 13.5388L10.2294 18.9463C9.03257 19.666 7.50836 18.804 7.50836 17.4075L7.50836 6.59251C7.50836 5.19597 9.03257 4.33398 10.2294 5.05368L19.2216 10.4612Z" fill="white"/></svg>';

    video.addEventListener('play', () => {
      if (playBtn) playBtn.style.display = 'none';
      if (playPause) playPause.innerHTML = pauseSvg;
    });
    video.addEventListener('pause', () => {
      if (!isDesktop && playBtn) playBtn.style.display = 'block';
      if (playPause) playPause.innerHTML = playSvg;
    });

    updateVolumeIcon();

    // Mobile close
    if (mbCloseBtn) {
      mbCloseBtn.addEventListener('click', () => this.closeModal());
    }

    // Comments button
    slide.querySelectorAll('.mh-comments-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const mediaId = btn.dataset.mediaId;
        if (mediaId) this.openComments(mediaId);
      });
    });

    // Like button
    slide.querySelectorAll('.mh-like-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });
  }

  formatTime(seconds) {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, '0')}`;
  }

  getTemplate(id) {
    const section = this.closest('monthly-highlights-list');
    if (section) {
      const tpl = section.querySelector(`#${id}`);
      return tpl ? tpl.innerHTML : '';
    }
    return '';
  }

  // ==================== Comments ====================

  initCommentsEvents() {
    // 评论面板在弹窗内只有一个实例，事件只需绑定一次
    const closeBtn = this.querySelector('.mh-comments-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeComments();
      });
    }
    const mask = this.querySelector('.mh-comments-mask');
    if (mask) {
      mask.addEventListener('click', (e) => {
        e.stopPropagation();
        this.closeComments();
      });
    }
    // 二级评论展开：事件委托到列表容器
    const list = this.querySelector('.mh-comments-list');
    if (list) {
      list.addEventListener('click', (e) => {
        const moreBtn = e.target.closest('.mh-more-replies');
        if (!moreBtn) return;
        this.fetchSubComments(
          moreBtn.dataset.id,
          moreBtn.dataset.total,
          moreBtn.dataset.subCommentId,
          moreBtn
        );
      });
    }
  }

  openComments(mediaId) {
    this.commentsMediaId = mediaId;
    this.commentsPage = 1;
    this.commentsHasMore = true;
    this.commentsOpen = true;

    // 清空上一个视频的评论，保留 footer
    const list = this.querySelector('.mh-comments-list');
    const footer = this.querySelector('.mh-comments-footer');
    if (list && footer) {
      list.querySelectorAll('.mh-comment-item').forEach((el) => el.remove());
      footer.style.display = 'flex';
    }
    const countEl = this.querySelector('.mh-reply-count');
    if (countEl) countEl.textContent = '';

    // 直接显示，无动画
    const panel = this.querySelector('.mh-comments-panel');
    const mask = this.querySelector('.mh-comments-mask');
    if (panel) panel.style.display = 'block';
    if (window.innerWidth < 1024 && mask) mask.style.display = 'block';
    if (this.swiper) this.swiper.allowTouchMove = false;

    this.fetchComments();
    this.initCommentsFooterObserver();
  }

  closeComments() {
    this.commentsOpen = false;
    this.commentsMediaId = '';
    const panel = this.querySelector('.mh-comments-panel');
    const mask = this.querySelector('.mh-comments-mask');
    if (panel) panel.style.display = 'none';
    if (mask) mask.style.display = 'none';
    if (this.swiper) {
      this.swiper.allowTouchMove = window.innerWidth < 1024;
    }
  }

  initCommentsFooterObserver() {
    const footer = this.querySelector('.mh-comments-footer');
    if (!footer) return;
    if (this._commentsObserver) this._commentsObserver.disconnect();
    this._commentsObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.commentsHasMore && this.commentsOpen) {
          this.commentsPage++;
          this.fetchComments();
        }
      });
    });
    this._commentsObserver.observe(footer);
  }

  fetchComments() {
    if (!this.commentsHasMore || !this.commentsMediaId) return;
    httpRequest
      .get(
        '/shopify/comment-list',
        {
          page: this.commentsPage,
          pageSize: this.commentsPageSize,
          mediaId: this.commentsMediaId,
          source: 1,
        },
        { baseUrl: this.baseUrl }
      )
      .then((res) => {
        if (res.code === 200) {
          if (res.data.list.length < this.commentsPageSize) {
            this.commentsHasMore = false;
            const footer = this.querySelector('.mh-comments-footer');
            if (footer) footer.style.display = 'none';
          }
          this.renderComments(res.data.list);
          const countEl = this.querySelector('.mh-reply-count');
          if (countEl) countEl.textContent = res.data.total;
        }
      });
  }

  renderComments(comments) {
    const template = this.getTemplate('mh-comment-template');
    const footer = this.querySelector('.mh-comments-footer');

    comments.forEach((item) => {
      let html = template
        .replace(/{commentId}/g, item.commentId || '')
        .replace(/{avatar}/g, item.user.avatar || '')
        .replace(/{nickname}/g, item.user.nickname || '')
        .replace(/{content}/g, item.content || '')
        .replace(/{time}/g, this.formatTimestamp(item.time));

      if (item.subCommentCount === 0) {
        html = html.replace(/{hasReply}/g, 'tw-hidden');
      } else if (item.subCommentCount === 1) {
        html = html
          .replace(/{hasReply}/g, 'tw-block')
          .replace(/{hasMore}/g, 'tw-hidden');
      } else {
        html = html
          .replace(/{hasReply}/g, 'tw-block')
          .replace(/{hasMore}/g, 'tw-block')
          .replace(/{moreNum}/g, item.subCommentCount - 1)
          .replace(/{total}/g, item.subCommentCount);
      }

      if (item.subComments && item.subComments.length > 0) {
        const sub = item.subComments[0];
        html = html
          .replace(/{subAvatar}/g, sub.user.avatar || '')
          .replace(/{subNickname}/g, sub.user.nickname || '')
          .replace(/{subContent}/g, sub.content || '')
          .replace(/{subTime}/g, this.formatTimestamp(sub.time))
          .replace(/{subCommentId}/g, sub.commentId || '');
      }

      if (footer) {
        footer.insertAdjacentHTML('beforebegin', html);
      }
    });
  }

  fetchSubComments(commentId, total, subCommentId, btn) {
    httpRequest
      .get(
        '/shopify/sub-comment-list',
        {
          page: 1,
          pageSize: total,
          mediaId: this.commentsMediaId,
          commentId: commentId,
          source: 1,
          subTopCommentIds: subCommentId,
        },
        { baseUrl: this.baseUrl }
      )
      .then((res) => {
        if (res.code === 200) {
          this.renderSubComments(commentId, res.data.list);
          btn.classList.add('tw-hidden');
        }
      });
  }

  renderSubComments(commentId, subComments) {
    const template = this.getTemplate('mh-comment-template');
    const container = this.querySelector(`[data-comment-id="${commentId}"]`);
    if (!container) return;

    subComments.forEach((item) => {
      const html = template
        .replace(/{avatar}/g, item.user.avatar || '')
        .replace(/{nickname}/g, item.user.nickname || '')
        .replace(/{content}/g, item.content || '')
        .replace(/{time}/g, this.formatTimestamp(item.time))
        .replace(/{hasReply}/g, 'tw-hidden');
      container.insertAdjacentHTML('beforeend', html);
    });
  }

  formatTimestamp(ts) {
    if (!ts) return '';
    const d = new Date(ts);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}

customElements.define('monthly-highlights-dialog', MonthlyHighlightsDialog);
